import { isProblem, NETWORK_PROBLEM_SLUG } from '@rooming/web-core';

// User-facing text for the problems the passenger app handles explicitly (ERROR_CATALOG.md). Anything else shows the
// server's own Spanish `title` — never a stack trace or an internal code.

const BY_SLUG: Record<string, string> = {
  [NETWORK_PROBLEM_SLUG]: 'Sin conexión. Revisá tu internet y probá de nuevo.',
  'plaza-ocupada': 'Esa plaza se acaba de ocupar. Elegí otra.',
  'modificacion-concurrente': 'Tu plaza cambió en otro dispositivo. Actualizamos el tablero.',
  'estado-desactualizado': 'Tu plaza cambió en otro dispositivo. Actualizamos el tablero.',
  'seleccion-cerrada': 'La selección de habitaciones está cerrada.',
  'plaza-incompatible': 'No podés elegir una plaza en esa habitación.',
  'ya-tiene-plaza': 'Ya tenés una plaza. Confirmá el cambio para moverte.',
  'terminos-pendientes': 'Para elegir una plaza tenés que aceptar los términos y condiciones del hotel.',
  'requiere-aprobacion':
    'Ese cambio lo tiene que aprobar un administrador de Funtour. Pedí tu plaza desde el tablero y Funtour se comunica con tu familia.',
  'solicitud-no-vigente': 'Esa solicitud ya no está vigente.',
  'distribucion-confirmada': 'La distribución ya está confirmada: para cambiar de habitación pedí un intercambio.',
  'umbral-no-alcanzado': 'Todavía no se alcanzó el 80 % de pasajeros con plaza.',
  'transicion-invalida': 'La distribución ya no está abierta para confirmarse.',
  'intercambios-no-disponibles': 'Los intercambios no están habilitados para tu grupo.',
  'intercambio-pendiente': 'Ya tenés una solicitud de intercambio pendiente.',
  'intercambio-no-vigente': 'Esa solicitud ya no está vigente: venció o ya fue respondida.',
  'intercambio-invalidado': 'Alguna de las plazas cambió: el intercambio quedó sin efecto.',
  'credenciales-invalidas': 'Usuario o contraseña incorrectos.',
  'enlace-de-activacion-invalido': 'Ese enlace no es válido. Pedile a tu guía que te lo mande de nuevo.',
  'enlace-de-activacion-vencido': 'Ese enlace ya no está disponible: venció o el grupo está cerrado.',
  'enlace-de-activacion-completo': 'Todo el grupo ya activó su cuenta, así que el enlace se cerró.',
  'activacion-no-disponible':
    'No encontramos un pasajero pendiente de activación con ese documento. Si ya activaste tu cuenta, ingresá con tu usuario y tu contraseña; si no, pedile ayuda a tu guía.',
  'demasiados-intentos': 'Demasiados intentos. Esperá un momento y probá de nuevo.',
  'sesion-vencida': 'Tu sesión terminó. Volvé a ingresar.',
  'cuenta-no-habilitada': 'Tu cuenta no está habilitada. Consultá con tu coordinador.',
  'demasiadas-solicitudes': 'Demasiadas solicitudes. Esperá un momento y probá de nuevo.',
  'sistema-ocupado': 'El sistema está muy ocupado. Probá de nuevo en unos segundos.',
};

export function messageOf(error: unknown): string {
  if (isProblem(error)) return BY_SLUG[error.slug] ?? error.title;
  return 'Ocurrió un error inesperado. Probá de nuevo.';
}
